import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { UploadTo } from "../../model/domain/UploadTo";

@Injectable({
  providedIn: "root",
})
export class TransferOrderService {
  constructor(private http: HttpClient) {}

  upload(file: File) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    return this.http.post(
      `${environment.apiUrls.files}/file-upload/transfer-order`,
      formData
    );
  }
}
